import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const ServicesService = {
  async getAllServices() {
    let response = await $axios.get($api("services")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addService(payload: any) {
    try {
      const { data, status } = await $axios.post($api("services"), payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
  async updateService(payload: any) {
    try {
      const { data, status } = await $axios.put(
        $api("services_id", { id: payload.id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteService(id: string) {
    let { data, status } = await $axios
      .delete($api("services_id", { id }), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },
};
